import React from "react";

/**
 * Binshare brand mark — the official iOS / Android app icon supplied by
 * the team. Lives at /icon-512.png (and the matching favicon.ico,
 * favicon.png, icon-180.png, icon-192.png copies) inside
 * /app/frontend/public/. Using the master PNG keeps the landing page,
 * favicon, Add-to-Home-Screen icon and native apps perfectly in sync.
 */
export default function Logo({ className = "w-9 h-9", title = "Binshare" }) {
  return (
    <img
      src="/icon-512.png"
      alt={title}
      width={40}
      height={40}
      className={`${className} object-contain rounded-[18%]`}
      loading="eager"
      decoding="async"
      draggable={false}
    />
  );
}
